import { Component, OnInit } from '@angular/core';
import { FontawesomeListService } from '@scaffold/services/fontawesome-list.service';
import { DataModelService } from '@services/data-model.service';
import { NbIconConfig } from '@nebular/theme';

@Component({
    selector: 'cat-config',
    templateUrl: './cat-config.component.html',
    styleUrls: ['../data-model-prefs/data-model-prefs.component.scss', './cat-config.component.scss']
})
export class CatConfigComponent implements OnInit {
    
    constructor(private dataModelService : DataModelService, private icons : FontawesomeListService) { }

    selectedDataCategory
    selectedCategory
    selectedIcon
  previewList = [];
    dataCategories = [];
    iconCategories = [];

    disableSave = false;
    
    ngOnInit() {
        this.iconCategories = this.icons.catagories;
        this.getCategories();

        this.dataModelService.updateTypeListTrigger().subscribe(() => {
            this.getCategories();
        })      
    }

    getCategories() {
        this.dataModelService.getCategories().subscribe(list => {
            this.dataCategories = list;
        })
    }
    
    getIconHtml(icon) {
        return '<i class="' + icon + '"></i>'
    }

    saveCategory() {
        this.disableSave = true;

        this.dataModelService.updateCategory(this.selectedDataCategory.id, { 'json_data' : { 'iconClass' : this.selectedIcon } } ).subscribe( data => {
            this.selectedDataCategory = null;
            this.selectedCategory = null;
            this.selectedIcon = null;

            this.disableSave = false;

            this.dataModelService.updateTypes();
        })
  }
  /**
* Convert FontAwesome icon class to a nBicon definition
* @param iconClass FontAweseome icon class
*/
  getIconDetails(iconClass: string): NbIconConfig {
    if (iconClass) {
      let details = iconClass.split(/\s/);
      if (details && details.length > 1) {
        let icon = {
          pack: details[0],
          icon: details[1].replace(/fa-/, "")
        }
        return icon
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
  //selectedDataCategory
  previewCat() {
    if (this.selectedDataCategory && this.selectedIcon) {
      this.previewList = [
        {
          title: this.selectedDataCategory.title,
          icon: this.getIconDetails(this.selectedIcon),
          children: [
            { title: "Item 1" }, { title: "Item 2" }
          ]
        }
      ]
    }
  }
}
